import { Flex } from '@chakra-ui/react';
import React from 'react';

import { SignupFormContainer } from 'packages/logged-out/ui/SignupFormContainer';
import { SignupSideColumn } from 'packages/logged-out/ui/SignupSideColumn';
import 'packages/logged-out/home.scss';
import { useSideBarContext } from 'packages/sidebar/hooks/sideBarContext';

export const SignupRoute = () => {
  const { setSideBarOpen } = useSideBarContext();
  return (
    <Flex
      align="center"
      justify={{ base: 'center', md: 'space-around', xl: 'space-between' }}
      direction={{ base: 'column-reverse', md: 'row' }}
      wrap="nowrap"
      minH="70vh"
      px={8}
      mb={16}
      maxWidth={['auto', 'auto', 'auto', '1080px']}
      margin="0 auto"
    >
      <SignupSideColumn />
      <SignupFormContainer onSubmit={() => setSideBarOpen(false)} />
    </Flex>
  );
};
